import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Col, Row } from 'antd';
import { injectIntl } from 'react-intl';
import moment from 'utils/cops-moment';

export const StyledRow = styled(Row)`
  width: 100%;
`;

const DaysSpan = styled.span`
  margin-left: 5px;
`;

const FollowUpCardContent = ({ action, intl, followUpTypes = [] }) => {
  const renderSince = () => {
    const diff = moment().startOf('day').diff(moment(action.since).startOf('day'), 'days');
    return action.since ?
      // eslint-disable-next-line max-len
      `${moment(action.since).format('L')} (${diff} ${intl.formatMessage({ id: `ticket.smart_actions.${diff === 1 ? 'DAY' : 'DAYS'}` })})` :
      '';
  };

  return (
    <>
      <StyledRow>
        <Col span={4}>
          <p>
            {`${intl.formatMessage({ id: 'ticket.smart_actions.TYPE' })}:`}
          </p>
        </Col>
        <Col span={20}>
          {followUpTypes?.find(c => c.id === action?.customerDownType)?.description}
        </Col>
      </StyledRow>
      <StyledRow>
        <Col span={4}>
          <p>
            {`${intl.formatMessage({ id: 'ticket.smart_actions.SINCE' })}:`}
          </p>
        </Col>
        <Col span={20}>
          {renderSince()}
        </Col>
      </StyledRow>
      <StyledRow>
        <Col span={4}>
          <p>
            {`${intl.formatMessage({ id: 'ticket.smart_actions.FOLLOW_UP' })}:`}
          </p>
        </Col>
        <Col span={20}>
          {action?.followUpByDisplayName}
        </Col>
      </StyledRow>
      <StyledRow>
        <Col span={4}>
          <p>
            {`${intl.formatMessage({ id: 'ticket.smart_actions.REMINDER' })}:`}
          </p>
        </Col>
        <Col span={20}>
          {intl.formatMessage(
            { id: `ticket.smart_actions.PER_${action?.reminder === 1 ? 'DAY' : 'DAYS'}` },
            { value: action?.reminder },
          )}
          <DaysSpan>
            {/* eslint-disable-next-line max-len */}
            {`(${Math.floor(moment().diff(action.since, 'days') / action?.reminder)} ${intl.formatMessage({ id: 'ticket.smart_actions.SENT' })})`}
          </DaysSpan>
        </Col>
      </StyledRow>
      <StyledRow>
        <Col span={4}>
          <p>
            {`${intl.formatMessage({ id: 'ticket.smart_actions.MANAGER' })}:`}
          </p>
        </Col>
        <Col span={20}>
          {action?.managerDisplayName}
        </Col>
      </StyledRow>
    </>
  );
};
FollowUpCardContent.propTypes = {
  action: PropTypes.object,
  intl: PropTypes.bool,
  followUpTypes: PropTypes.array,
};

export default injectIntl(FollowUpCardContent);
